export const config = {
    appname: 'Bioderma',
    client_id: '1269055400136680', // App ID
    facebook_app_id: '1269055400136680', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Production Settings ----------------
    api: 'apibdm2',
    agency_id: '',
    bzbsUrl: 'https://apibdm2.buzzebees.com',
    bzbsModuleUrl: 'https://biodermamodule.buzzebees.com',
    bzbsAddItemFromList: 'https://shoppingcartmodule14.buzzebees.com/',
    bzbsBlobUrl: '	https://cdn.buzzebees.com/th',
    bzbsShoppingCartUrl: 'https://shoppingcartservice14.buzzebees.com/',
    bzbsAddItem: 'https://cart.buzzebees.com/payment/AddItem.aspx?id=',
    bzbsShoppingBasket: 'https://cart.buzzebees.com/paymentV2/cart.aspx',
    bzbsWebUrl: 'https://www.buzzebees.com',
    bzbsPointExpire: 'https://www.buzzebees.com/Views/Point/Expire.aspx?token=',
    miscUrl: 'https://misc.buzzebees.com',
    bzbsGaId: '',
    liffId: '1655767577-nyXkNPA2',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "AIzaSyA23HGBOG71GlTn8fLq_KRFpQCMhyfHD-Q",
        authDomain: "bioderma-production-71ad2.firebaseapp.com",
        projectId: "bioderma-production-71ad2",
        storageBucket: "bioderma-production-71ad2.appspot.com",
        messagingSenderId: "1076076290656",
        appId: "1:1076076290656:web:57bd40b4deac97057a9905"
    },
};
